import { AttachFile, Close, Download, Send } from "@mui/icons-material";
import {
    Button,
    Card,
    CircularProgress,
    FormControl,
    Grid,
    IconButton,
    TextField,
    Typography,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import LoadingBox from "../../Layouts/LoadingStyle";
import {
    GetAllMessages,
    messagesReset,
    SendMessageMethod,
} from "../../Redux/MessagesSlice/MessagesSlice";
import Pusher from "pusher-js";

const AllMessagesContainer = () => {
    const { department_id_receiver, site_receiver, user_receiver, user_name } =
        useParams();

    const [Files, setFiles] = useState({
        type: "",
        path: "",
    });

    const { pusher_data } = useSelector((state) => state.pusher);

    const PusherData = pusher_data || [];

    // Automatically scroll down chat Container
    const ScrollingDown = () => {
        let container = window.document.getElementById(
            "massages-box-container"
        );
        if (container) {
            container.scrollTop = container.scrollHeight;
        }
        // container.scrollTop += 1000;
    };

    ScrollingDown();

    useEffect(() => {
        if (PusherData) {
            AppendMessageFromPusher(
                PusherData?.data?.body,
                PusherData?.data?.file
            );
            // if (messageVal) AppendMessageToMembersContainer(messageVal);
            let container = window.document.getElementById(
                "massages-box-container"
            );
            if (container) {
                container.scrollTop = container.scrollHeight;
            }
        }
    }, [PusherData]);

    const { mainUser } = useSelector((state) => state.auth);
    const user_id = mainUser?.data?.id;

    const { sendMessage, messages, isSuccess, isLoading, isError, errors } =
        useSelector((state) => state.messages);
    const AllMessages = messages?.data || [];
    const messageVal = sendMessage?.data || [];
    const [MemberPositionBox, setMemberPositionBox] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        const CallGetAllMessages = async () => {
            await dispatch(
                GetAllMessages({
                    user_receiver: user_receiver,
                    site_receiver: site_receiver,
                })
            );
            await dispatch(messagesReset());
        };
        CallGetAllMessages();
    }, [site_receiver, dispatch, user_receiver, user_name]);

    // ========================
    // == Handel Formik Form ==
    // ========================

    const formik = useFormik({
        initialValues: {
            department_id_sender: 2,
            site_sender: "crm",
            user_receiver: "",
            site_receiver: "",
            department_id_receiver: "",
            body: "",
            file_path: "",
        },

        onSubmit: async (values) => {
            const formData = new FormData();
            setFiles({
                type: "",
                path: "",
            });
            formData.append("user_sender", user_id);
            formData.append(
                "department_id_sender",
                formik.values.department_id_sender
            );
            formData.append("site_sender", formik.values.site_sender);
            formData.append("user_receiver", user_receiver);
            formData.append("site_receiver", site_receiver);
            formData.append("department_id_receiver", department_id_receiver);
            formData.append("body", formik.values.body);
            formData.append("file_path", formik.values.file_path);
            if (formik.values.body) {
                CallAppendMessageToContainer(formik.values.body);
                formik.values.body = "";
            }
            setMemberPositionBox(true);
            // if (formik.values.body || formik.values.file_path) {
            await dispatch(SendMessageMethod(formData));
            await dispatch(messagesReset());
            // }
        },
    });

    const handleChangeImage = (e) => {
        formik.values.file_path = e.currentTarget.files[0];
        let src = URL.createObjectURL(e.currentTarget.files[0]);
        let extension = e.currentTarget.files[0].name.split(".").pop();
        setFiles({
            type: extension,
            path: src,
        });
    };

    useEffect(() => {
        if (isError) {
            if (errors) {
                Object.keys(errors).forEach((key) => {
                    let error = errors[key][0];
                    toast.error(error);
                });
            } else {
                toast.error("You Must Enter Message Or Upload File");
            }
            const reset = async () => {
                await dispatch(messagesReset());
            };
            reset();
        }
    }, [isError, errors, dispatch]);

    const AppendMessageFromPusher = (body, path) => {
        const MessagesContainer = document.getElementById(
            "massages-box-container"
        );
        if (body) {
            let message = `
                    <div class="message">
                        <div class="message-receiver">
                            <span>${body}</span>
                            <div class="clear"> </div>
                        </div>
                    </div>
                `;
            MessagesContainer.innerHTML += message;
        }

        if (path) {
            let src = path.split(".");
            let extension = src[src.length - 1];
            let image_type = ["jpg", "png", "svg"];
            let file = `
            <div class="message">
                    <div class="message-receiver">
                        <span>
                            ${
                                image_type.includes(extension)
                                    ? `<img
                                class="chat-preview-file image-preview-chat"
                                src="${path}"
                                alt=""
                            />`
                                    : ""
                            }
                            ${
                                extension === "pdf"
                                    ? `
                                        <embed
                                        src="${path}"
                                        width="400"
                                        class="chat-preview-file pdf-preview-chat"
                                        height="400"
                                    ></embed>
                            `
                                    : ""
                            }
                            ${
                                extension === "docx"
                                    ? `
                            <a href="${path}" download="${path}" target="_blank">
                                Another File
                            </a>`
                                    : ""
                            }
                        </span>
                        <div class="clear"> </div>
                    </div>
                </div>
            `;
            MessagesContainer.innerHTML += file;
            formik.values.file_path = "";
        }
    };

    // ======================
    // All Member Information Box
    // ======================
    const GetPusherLinkID = (chat) => {
        let department_id = department_id_receiver;

        let site = site_receiver;

        let user_id = user_receiver;

        return `member-id-chat-${department_id}-${site}-${user_id}`;
    };

    const GetPusherLinkSRC = (chat) => {
        let department_id = department_id_receiver;

        let site = site_receiver;

        let user_id = user_receiver;

        let name = user_name;

        return `${department_id}/${site}/${user_id}/${name}`;
    };

    const GetMessageDate = (date) => {
        const MessageDate = new Date(date).toLocaleDateString();
        return MessageDate;
    };

    const AppendMessageToMembersContainer = (data) => {
        console.log("AppendMessageToMembersContainer");
        const id = GetPusherLinkID({
            department_id_receiver: department_id_receiver,
            site_receiver: site_receiver,
            user_receiver: user_receiver,
            user_name: user_name,
        });
        const link = GetPusherLinkSRC({
            department_id_receiver: department_id_receiver,
            site_receiver: site_receiver,
            user_receiver: user_receiver,
            user_name: user_name,
        });
        const MainDiv = document.getElementById(id);
        if (MainDiv) {
            MainDiv.remove();
        }

        const NewElement =
            document.getElementsByClassName("main-member-box")[0];
        if (NewElement) {
            const parent = NewElement.parentNode;
            const helper = document.createElement("div");
            helper.innerHTML = `
            <a id="${id}" class="main-member-box" href="/messages/${link}">
                <div class="member-box">
                    <div class="MuiGrid-root MuiGrid-container css-11lq3yg-MuiGrid-root">
                        <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-md-2 css-1qnu8s0-MuiGrid-root">
                            <div class="MuiListItemAvatar-root member-avatar css-95qvis-MuiListItemAvatar-root">
                                <div class="MuiAvatar-root MuiAvatar-circular MuiAvatar-colorDefault css-2s90m6-MuiAvatar-root">
                                    <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiAvatar-fallback css-10mi8st-MuiSvgIcon-root-MuiAvatar-fallback" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="PersonIcon">
                                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z">
                                        </path>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-8 MuiGrid-grid-md-7 css-1cd8t37-MuiGrid-root">
                            <div>
                                <h6 class="MuiTypography-root MuiTypography-h6 css-oblp1g-MuiTypography-root">
                                    ${user_name}
                                <span class="MuiTypography-root MuiTypography-span css-1vvhe1j-MuiTypography-root">
                                - ${site_receiver} </span>
                                </h6>
                                <span class="MuiTypography-root MuiTypography-span css-19g4n3h-MuiTypography-root">
                                ${data?.body}
                                </span>
                            </div>
                        </div>
                        <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-4 MuiGrid-grid-md-3 read-date css-g04lnj-MuiGrid-root">
                            <p class="MuiTypography-root MuiTypography-body1 MuiTypography-alignCenter css-xzvudl-MuiTypography-root message-date">
                            ${GetMessageDate(data.created_at)}
                            </p>
                            <span class="done-all-icon"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root" style="var(--light-blue);" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="DoneAllIcon"><path d="m18 7-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41 6 19l1.41-1.41L1.83 12 .41 13.41z"></path></svg></span>
                        </div>
                    </div>
                </div>
            </a>
            `;
            // helper.innerHTML = `
            //         <a id="${id}" class="main-member-box" href="/messages/${link}">
            //             <div class="member-box">
            //                 <div class="MuiGrid-root MuiGrid-container css-11lq3yg-MuiGrid-root">
            //                     <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-md-2 css-1qnu8s0-MuiGrid-root">
            //                         <div class="MuiListItemAvatar-root member-avatar css-95qvis-MuiListItemAvatar-root">
            //                             <div class="MuiAvatar-root MuiAvatar-circular MuiAvatar-colorDefault css-2s90m6-MuiAvatar-root">
            //                                 <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiAvatar-fallback css-10mi8st-MuiSvgIcon-root-MuiAvatar-fallback" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="PersonIcon">
            //                                     <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z">
            //                                     </path>
            //                                 </svg>
            //                             </div>
            //                         </div>
            //                     </div>
            //                     <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-8 MuiGrid-grid-md-7 css-1cd8t37-MuiGrid-root">
            //                         <div>
            //                             <h6 class="MuiTypography-root MuiTypography-h6 css-oblp1g-MuiTypography-root">
            //                                 ${user_name}
            //                             <span class="MuiTypography-root MuiTypography-span css-1vvhe1j-MuiTypography-root">
            //                                 - ${site_receiver} </span>
            //                             </h6>
            //                             <span class="MuiTypography-root MuiTypography-span css-19g4n3h-MuiTypography-root">
            //                             <span class="MuiTypography-root MuiTypography-span css-1kbbegv-MuiTypography-root">You :</span>
            //                             ${data?.body}
            //                             </span>
            //                         </div>
            //                     </div>
            //                     <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-4 MuiGrid-grid-md-3 read-date css-g04lnj-MuiGrid-root">
            //                         <p class="MuiTypography-root MuiTypography-body1 MuiTypography-alignCenter css-xzvudl-MuiTypography-root">
            //                                 ${GetMessageDate(data.created_at)}
            //                         </p>
            //                         <svg
            //                                 class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root"
            //                                 focusable="false"
            //                                 aria-hidden="true"
            //                                 viewBox="0 0 24 24"
            //                                 data-testid="DoneIcon"
            //                             >
            //                             <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path>
            //                         </svg>
            //                     </div>
            //                 </div>
            //             </div>
            //         </a>
            //     `;
            // <div class="new-message-container"><span class="new-message">1</span></div>

            while (helper.firstChild) {
                parent.insertBefore(helper.firstChild, NewElement);
            }
        } else {
            const element = document.getElementById("live-members-box");
            let member = `
                    <a id="${id}" class="main-member-box" href="/messages/${link}">
                        <div class="member-box">
                            <div class="MuiGrid-root MuiGrid-container css-11lq3yg-MuiGrid-root">
                                <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-md-2 css-1qnu8s0-MuiGrid-root">
                                    <div class="MuiListItemAvatar-root member-avatar css-95qvis-MuiListItemAvatar-root">
                                        <div class="MuiAvatar-root MuiAvatar-circular MuiAvatar-colorDefault css-2s90m6-MuiAvatar-root">
                                            <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiAvatar-fallback css-10mi8st-MuiSvgIcon-root-MuiAvatar-fallback" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="PersonIcon">
                                                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z">
                                                </path>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-8 MuiGrid-grid-md-7 css-1cd8t37-MuiGrid-root">
                                    <div>
                                        <h6 class="MuiTypography-root MuiTypography-h6 css-oblp1g-MuiTypography-root">
                                            ${user_name}
                                        <span class="MuiTypography-root MuiTypography-span css-1vvhe1j-MuiTypography-root">
                                            - ${site_receiver} </span>
                                        </h6>
                                        <span class="MuiTypography-root MuiTypography-span css-19g4n3h-MuiTypography-root">
                                        <span class="MuiTypography-root MuiTypography-span css-1kbbegv-MuiTypography-root">You :</span>
                                        ${data?.body}
                                        </span>
                                    </div>
                                </div>
                                <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-4 MuiGrid-grid-md-3 read-date css-g04lnj-MuiGrid-root">
                                    <p class="MuiTypography-root MuiTypography-body1 MuiTypography-alignCenter css-xzvudl-MuiTypography-root">
                                            ${GetMessageDate(data.created_at)}
                                    </p>
                                    <svg
                                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root"
                                            focusable="false"
                                            aria-hidden="true"
                                            viewBox="0 0 24 24"
                                            data-testid="DoneIcon"
                                        >
                                        <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </a>
                `;
            element.innerHTML += member;
        }
    };

    const CallAppendMessageToContainer = (body, path) => {
        const MessagesContainer = document.getElementById(
            "massages-box-container"
        );
        if (body) {
            // If The Member Send Just Message
            let message = `
                    <div class="message">
                        <div class="message-sent">
                            <span>${body}</span>
                            <div class="clear"> </div>
                        </div>
                    </div>
                `;
            MessagesContainer.innerHTML += message;
        }
        if (path) {
            let src = path.split(".");
            let extension = src[src.length - 1];
            let image_type = ["jpg", "png", "svg"];
            let file = `
                <div class="message">
                    <div class="message-sent">
                        <span>
                            ${
                                image_type.includes(extension)
                                    ? `<img
                                class="chat-preview-file image-preview-chat"
                                src="${path}"
                                alt=""
                            />`
                                    : ""
                            }
                            ${
                                extension === "pdf"
                                    ? `
                                        <embed
                                        src="${path}"
                                        width="400"
                                        class="chat-preview-file pdf-preview-chat"
                                        height="400"
                                    ></embed>
                            `
                                    : ""
                            }
                            ${
                                extension === "docx"
                                    ? `
                            <a href="${path}" download="${path}" target="_blank">
                                Another File
                            </a>`
                                    : ""
                            }
                        </span>
                        <div class="clear"> </div>
                    </div>
                </div>
            `;
            MessagesContainer.innerHTML += file;
        }
    };

    useEffect(() => {
        if (isSuccess && messageVal.length !== 0) {
            CallAppendMessageToContainer("", messageVal.file);
            if (MemberPositionBox) {
                AppendMessageToMembersContainer(messageVal);
                setMemberPositionBox(false);
            }
            formik.values.body = "";
            formik.values.file_path = "";
            dispatch(messagesReset());
        }
    }, [isSuccess, messageVal, MemberPositionBox]);

    // ================================================================
    // Handel Change Member Box New Message Status From un seen To seen
    // ================================================================
    document.addEventListener("mousemove", (e) => {
        let MemberBox = document.getElementById(
            `member-id-chat-${department_id_receiver}-${site_receiver}-${user_receiver}`
        );
        if (MemberBox) {
            let MemberBox = document
                .getElementById(
                    `member-id-chat-${department_id_receiver}-${site_receiver}-${user_receiver}`
                )
                .getElementsByClassName("new-message-container")[0];
            let NewElement = document.getElementById(
                `member-id-chat-${department_id_receiver}-${site_receiver}-${user_receiver}`
            );
            if (MemberBox) {
                MemberBox.remove();
                if (NewElement) {
                    let NewElement = document
                        .getElementById(
                            `member-id-chat-${department_id_receiver}-${site_receiver}-${user_receiver}`
                        )
                        .getElementsByClassName("message-date")[0];
                    const parent = NewElement.parentNode;
                    if (parent) {
                        parent.innerHTML += `
                                <span class="done-all-icon"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root" style="var(--light-blue);" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="DoneAllIcon"><path d="m18 7-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41 6 19l1.41-1.41L1.83 12 .41 13.41z"></path></svg></span>
                            `;
                    }
                    // parent.innerHTML += `<div> Test </div>`;
                    // const helper = document.createElement("div");
                    // // Done Icon To Append
                    // helper.innerHTML = `
                    //     <span class="done-all-icon"><svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="DoneAllIcon"><path d="m18 7-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41 6 19l1.41-1.41L1.83 12 .41 13.41z"></path></svg></span>
                    // `;
                    // parent.insertBefore(helper.firstChild, NewElement);
                }
            }
        }
    });

    // ============================================================
    // Handle Render The File And Check if Is Image Or File To Show
    // ============================================================
    const RenderFilePreviewOnChat = (path) => {
        let src = path.split(".");
        let extension = src[src.length - 1];
        let image_type = ["jpg", "png", "svg"];
        if (image_type.includes(extension)) {
            return (
                <img
                    className="chat-preview-file image-preview-chat"
                    src={path}
                    alt=""
                />
            );
        } else if (extension === "pdf") {
            return (
                <embed
                    src={path}
                    width="400"
                    className="chat-preview-file pdf-preview-chat"
                    height="400"
                ></embed>
            );
        } else {
            return (
                <a href={path} download={path} target="_blank">
                    Another File
                </a>
            );
        }
    };

    const GetSingleMessage = (message) => {
        return (
            <>
                {message.body && (
                    <div className="message">
                        <div
                            className={
                                message.user_receiver
                                    ? "message-sent"
                                    : "message-receiver"
                            }
                        >
                            <span>{message.body}</span>
                            <div className="clear"> </div>
                        </div>
                    </div>
                )}
                {message.file && (
                    <div className="message">
                        <div
                            className={
                                message.user_receiver
                                    ? "message-sent"
                                    : "message-receiver"
                            }
                        >
                            <span>{RenderFilePreviewOnChat(message.file)}</span>
                            <div className="clear"> </div>
                        </div>
                    </div>
                )}
            </>
        );

        // if (message.user_receiver) {
        //     if (message.body) {
        //         if (message.file) {
        //             return (
        //                 <>
        //                     <div className="message-sent">
        //                         <span>{message.body}</span>
        //                         <div className="clear"> </div>
        //                     </div>
        //                     <div className="message-sent">
        //                         <span>
        //                             <a
        //                                 href={message.file}
        //                                 download={message.file}
        //                                 target="_blank"
        //                             >
        //                                 Show File
        //                             </a>
        //                             {/* <Button
        //                                 onClick={(e) =>
        //                                     handelDownloadPdfFile(message.file)
        //                                 }
        //                             >
        //                                 Show File
        //                                 <Download sx={{ color: "white" }} />
        //                             </Button> */}
        //                         </span>
        //                         <div className="clear"> </div>
        //                     </div>
        //                 </>
        //             );
        //         } else {
        //             return (
        //                 <div className="message-sent">
        //                     <span>{message.body}</span>
        //                     <div className="clear"> </div>
        //                 </div>
        //             );
        //         }
        //     } else {
        //         return (
        //             <div className="message-sent">
        //                 <span>
        //                     <a
        //                         href={message.file}
        //                         download={message.file}
        //                         target="_blank"
        //                     >
        //                         Show File
        //                     </a>
        //                     {/* <Button
        //                         onClick={(e) =>
        //                             handelDownloadPdfFile(message.file)
        //                         }
        //                     >
        //                         Show File
        //                         <Download sx={{ color: "white" }} />
        //                     </Button> */}
        //                 </span>
        //                 <div className="clear"> </div>
        //             </div>
        //         );
        //     }
        // } else {
        //     if (message.body) {
        //         if (message.file) {
        //             return (
        //                 <>
        //                     <div className="message-receiver">
        //                         <span>{message.body}</span>
        //                         <div className="clear"> </div>
        //                     </div>
        //                     <div className="message-receiver">
        //                         <span>
        //                             <a
        //                                 href={message.file}
        //                                 download={message.file}
        //                                 target="_blank"
        //                             >
        //                                 Show File
        //                             </a>
        //                             {/* <Button
        //                                 onClick={(e) =>
        //                                     handelDownloadPdfFile(message.file)
        //                                 }
        //                             >
        //                                 Show File
        //                                 <Download sx={{ color: "white" }} />
        //                             </Button> */}
        //                         </span>
        //                         <div className="clear"> </div>
        //                     </div>
        //                 </>
        //             );
        //         } else {
        //             return (
        //                 <div className="message-receiver">
        //                     <span>{message.body}</span>
        //                     <div className="clear"> </div>
        //                 </div>
        //             );
        //         }
        //     } else {
        //         return (
        //             <div className="message-receiver">
        //                 <span>
        //                     <a
        //                         href={message.file}
        //                         download={message.file}
        //                         target="_blank"
        //                     >
        //                         Show File
        //                     </a>
        //                     {/* <Button
        //                         onClick={(e) =>
        //                             handelDownloadPdfFile(message.file)
        //                         }
        //                     >
        //                         Show File
        //                         <Download sx={{ color: "white" }} />
        //                     </Button> */}
        //                 </span>
        //                 <div className="clear"> </div>
        //             </div>
        //         );
        //     }
        // }
    };

    const handelRemoveFile = () => {
        formik.values.file_path = "";
        setFiles({
            type: "",
            path: "",
        });
    };

    // let container = document.getElementById("message-container");
    // if (container) {
    //     container.addEventListener("drop", (e) => {
    //         e.preventDefault();
    //         console.log("done");
    //         // console.log(e);
    //     });
    //     container.addEventListener("dragover", () => {
    //         console.log(container);
    //     });
    // }
    // const componentDidMount = () => {
    // };
    // componentDidMount();
    const dropHandler = (e) => {
        e.preventDefault();
        console.log(e);
        // console.log("dropHandler", e);
    };

    const dragOverHandler = (e) => {
        e.preventDefault();
        console.log(e);
        // console.log("dragOverHandler", e);
    };
    return (
        <MessagesContainer
            id="message-container"
            ondrop={(e) => dropHandler()}
            ondragover={(e) => dragOverHandler()}
        >
            <Card sx={{ background: "var(--white)" }}>
                <Typography
                    mt={2}
                    variant="h5"
                    sx={{ fontWeight: "700", padding: "10px" }}
                    align="center"
                    color="primary"
                >
                    {user_name}
                </Typography>
            </Card>
            {/* {isLoading && messagesFeach && (
                <LoadingBox className="loading">
                    <CircularProgress />
                </LoadingBox>
            )} */}
            {/* {!isLoading  && ( */}
            <AllMessagesBox
                className="massages-box"
                id="massages-box-container"
            >
                {AllMessages.map((message, index) => (
                    <div key={index}>{GetSingleMessage(message)}</div>
                ))}
            </AllMessagesBox>
            {/* )} */}

            <form onSubmit={formik.handleSubmit}>
                <FormControl fullWidth>
                    <SendMessageBox>
                        <Grid container columns={12}>
                            <Grid
                                item
                                md={1}
                                xs={1}
                                sx={{
                                    justifyContent: "center",
                                    display: "flex",
                                }}
                            >
                                <Button component="label">
                                    <AttachFile />
                                    <input
                                        hidden
                                        type="file"
                                        name="file_path"
                                        id="file_path"
                                        onChange={(e) => handleChangeImage(e)}
                                    />
                                </Button>
                            </Grid>
                            <Grid item md={10} xs={10}>
                                <TextField
                                    id="body"
                                    fullWidth
                                    name="body"
                                    value={formik.values.body}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={1}
                                md={1}
                                sx={{
                                    justifyContent: "center",
                                    display: "flex",
                                }}
                            >
                                <IconButton
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                >
                                    <Send />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </SendMessageBox>
                </FormControl>
            </form>
            {["jpg", "png", "svg"].includes(Files.type) && (
                <div
                    sx={{ display: "flex", justifyContent: "center" }}
                    id="message-file-preview"
                >
                    <div id="delete-file-btn">
                        <Button
                            onClick={() => {
                                handelRemoveFile();
                            }}
                        >
                            <Close />
                        </Button>
                    </div>
                    <img className="file-path-show" src={Files.path} alt="" />
                </div>
            )}

            {Files.type === "pdf" && (
                <div
                    sx={{ display: "flex", justifyContent: "center" }}
                    id="message-file-preview"
                >
                    <div id="delete-file-btn">
                        <Button
                            onClick={() => {
                                handelRemoveFile();
                            }}
                        >
                            <Close />
                        </Button>
                    </div>
                    <embed
                        src={Files.path}
                        width="400"
                        class="file-path-show"
                        height="400"
                    ></embed>
                </div>
            )}
        </MessagesContainer>
    );
};
const MessagesContainer = styled.div`
    position: relative;
    #message-file-preview {
        display: flex;
        justify-content: center;
        position: absolute;
        top: 0;
        background: var(--dark-gray);
        width: 100%;
        height: calc(90%);
        padding: 10px;
    }
    .file-path-show {
        width: 100%;
        height: 100%;
        border-radius: 11px;
        box-shadow: -1px 5px 11px;
    }
    #delete-file-btn {
        position: absolute;
        right: 0;
    }
    #delete-file-btn button {
        background: var(--gray);
    }
    #delete-file-btn button svg {
        color: var(--white);
    }
`;

const SendMessageBox = styled.div`
    display: flex;
    button svg {
        font-size: 1.8em;
    }
`;

const AllMessagesBox = styled.div`
    overflow-y: scroll;
    margin-top: 15px;
    padding: 15px;
    height: calc(80vh - 80px);

    .message {
        margin-top: 21px;
    }

    .message div span {
        display: inline-flex;
        border-radius: 10px;
        padding-right: 20px;
        padding-left: 20px;
        padding: 8px;
        max-width: 80%;
        overflow-wrap: anywhere;
    }
    .message div .chat-preview-file {
        max-width: 300px;
        max-height: 300px;
    }
    .message div span button span,
    .message div span button {
        color: var(--white) !important;
    }
    .message div.message-sent span {
        float: right;
        background: var(--light-blue);
        color: var(--white);
    }
    .message div.message-receiver span {
        background: var(--gray);
        color: var(--white);
    }
    .message div.message-sent span a.file-append {
        color: var(--white);
        text-decoration: revert;
    }

    .message div.message-sent,
    .message div.message-receiver {
        margin-top: 7px;
    }
    .clear {
        clear: both;
    }
`;
export default AllMessagesContainer;
